module.exports = __webpack_public_path__ + "img/gate_full.51413897.jpg";